import React from 'react';
import ReviewFormWizard from '../../../ReviewFormPage/components/ReviewFormWizard/ReviewFormWizard';

interface IReviewFormProps {
  provider?: any;
  customer?: any;
  formFields?: any[];
  submittedMsg?: string;
  onSave?: (e: any) => void;
  onSubmit?: (e?: any) => void;
}

const ReviewForm: React.FC<React.PropsWithChildren<IReviewFormProps>> = ({
  onSave,
  onSubmit,
  customer,
  provider,
  formFields,
  submittedMsg,
}) => {
  return (
    <div>
      <ReviewFormWizard
        type="provider"
        fields={formFields}
        providerName={provider?.name}
        customerName={customer?.name}
        submitted={submittedMsg}
        onSave={onSave}
        onSubmit={onSubmit}
      />
    </div>
  );
};
export default ReviewForm;
